<template>
  <div class="cart-summary">

    <CustomModal 
    :title="'Confirmation de la commande : MYSATAB_'+getPnumbon"
    :open="open"
    :keepratio="true"
    :size="'sm'"
    @close-modal="open=false">
      <template slot="modal_content">
        <p>{{$_('order_finish')}}</p>
      </template>
      <template slot="modal_footer">
        <div class="button-bar">
          <button class="btn" @click="confirmOrder">{{$_('yes')}}</button>
          <button class="btn" @click="open = false">{{$_('no')}}</button>
        </div>
      </template>
    </CustomModal>

    <CustomModal 
    :open="open_result"
    :type="type_result"
    @close-modal="open_result = false">
      <template slot="modal_content">
        <p>{{message_result}}</p>
      </template>
    </CustomModal>

    <div class="cart-summary-container">
      <div class="cart-summary-line">
        <span class="cart-summary-line-libelle">{{$_('sub_total')}} HT</span>
        <span class="cart-summary-line-value">{{getSubTotal}} {{getDev}}</span>
      </div>
      <div class="cart-summary-line">
        <span class="cart-summary-line-libelle">{{$_('including_delivery')}} HT</span>
        <span class="cart-summary-line-value">{{getDeliveryPrice}} {{getDev}}</span>
      </div>
      <div class="cart-summary-total">
        <span class="cart-summary-total-libelle"><strong>{{$_('ttc_total').toUpperCase()}}</strong></span>
        <span class="cart-summary-total-value">{{getTotal}} {{getDev}}</span>
      </div>
      <div class="delivery-info-container" v-if="step === 'cartdelivery' || step === 'payment'">
        <div class="cart-summary-delivery">
          <h3>{{$_('delivery_address')}}</h3>
          <span v-for="(value, propertyName, index) in display_delivery_address" :key="index">{{(propertyName !== 'TTYP_ADR' && propertyName !== 'TCPAYSL' && propertyName !== 'TCPAYS' && propertyName !== 'TCPROVL' && propertyName !== 'TCPROV') ? value : ''}}</span>
        </div>
        <div class="cart-summary-billing">
          <h3>{{$_('billing_address')}}</h3>
          <span v-for="(value, propertyName, index) in display_billing_address" :key="index">{{(propertyName !== 'TTYP_ADR' && propertyName !== 'TCPAYSF' && propertyName !== 'TCPAYS' && propertyName !== 'TCPROVF' && propertyName !== 'TCPROV') ? value : ''}}</span>
        </div>
      </div>
      
      <div class="cart-summary-validate" v-if="this.$props.step === 'payment' && getPaymentReady">
        <button v-if="getDisplayButton === true" class="btn btn-libelle" @click="vNextStep">{{button_title}}</button>
        <span class="order-lock" v-if="lock_step === true">{{$_('order_lock')}}</span>
      </div>
      <div class="cart-summary-validate" v-else-if="this.$props.step !== 'payment'">
        <button v-if="getDisplayButton === true" class="btn btn-libelle" @click="vNextStep">{{button_title}}</button>
        <span class="order-lock" v-if="lock_step === true">{{$_('order_lock')}}</span>
      </div>
      <div v-else class="btn-loading">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <div class="cart-summary-bottom">
      <img src="../assets/img/lock.png" />
      <span>{{$_('secure_payment')}}</span>
    </div>
  </div>
</template>

<script>

import cartService from '@/modules/panier/services/cartService';
import CustomModal from "@/common/components/widget/Modal/CustomModal";

export default {
  name: 'CartSummary',
  data() {
    return {
      display_billing_address: {},
      billing_address: {
        TNOM: "",
        TADR1: "",
        TADR2: "",
        TADR3: "",
        TCPOST: "",
        TVILLE: "",
        TLPAYS: "",
        TLPROV: "",
        TCPAYS: "",
        TCPROV: "",
        TTEL: ""
      },
      display_delivery_address: {},
      delivery_address: {
        TNOM: "",
        TADR1: "",
        TADR2: "",
        TADR3: "",
        TCPOST: "",
        TVILLE: "",
        TLPAYS: "",
        TLPROV: "",
        TCPAYS: "",
        TCPROV: "",
        TTEL: ""
      },
      button_title: '',
      open: false,
      open_result: false,
      message_result: '',
      type_result: '',
      lock_step: false
    }
  },
  props: {
    step: {
      type: String,
      default: 'cart',
    },
    next_step: {
      type: String,
      default: 'cart',
    },
    payment: {
      type: String,
      default: 'transfer',
    }
  },
  components: {
    CustomModal
  },
  created() {

    this.getDisplayCurrentAddr();
    this.getCurrentAddr();
    
    switch (this.$props.step) {
        case 'cartdelivery':
          this.button_title = this.$_('next');
          break;
        case 'payment':
          this.button_title = this.$_('pay');
          break;
        default: 
          this.button_title = this.$_('next');
          break;
    }
  },
  methods: {
    vNextStep() {
    
      switch (this.$props.step) {
        case 'cartdelivery':
          var customer_addr = Array();

          customer_addr.push(this.billing_address, this.delivery_address);

          customer_addr.map(obj => {
            delete obj.TLPAYS;
            delete obj.TLPROV;
            delete obj.TTEL;
            // delete obj.TTYP_ADR;       
            // delete obj.TCPAYS;     
            delete obj.TNLIG;  
            delete obj.TADR_DEFAUT;   
          });

          this.button_title = this.$_('next');

          cartService.setCustomerCartAddr(customer_addr)
          .then(res => {
            if(res.data !== undefined && res.data.POK === 1) {
              this.$router.push({name: this.$props.next_step});
            }
          })
          break;

        case 'payment':

          if(this.$store.getters['panier/get_payment_method'] === 'bankcard') {
            this.$store.getters['panier/get_payment_form'].submit(); 
          } else if(this.$store.getters['panier/get_payment_method'] === 'transfer') {
            this.open = true;
          }

          break;

        default:

          this.$parent.$children[1].$children.some(line => {
            if(line.$data.display_add_to_cart === false) {
              this.lock_step = true;
              return true;
            } else {
              this.lock_step = false
            }
          });
          
          if(this.lock_step === false) {
            this.$router.push({name: this.$props.next_step});
          }

          break;
      }
    },
    getDisplayCurrentAddr() {
      cartService.getDisplayCurrentAddr()
        .then(res => {
          if(res.data.DS_OL !== undefined) {
            this.display_delivery_address = res.data.DS_OL.OUT[0];
            this.$store.dispatch('panier/SET', {key: 'display_delivery_address', value: this.display_delivery_address});
          }
          if(res.data.DS_OF !== undefined) {
            this.display_billing_address = res.data.DS_OF.OUT[0];
            this.$store.dispatch('panier/SET', {key: 'display_billing_address', value: this.display_billing_address});
          }

          
        });
    },
    confirmOrder() {

      cartService.usualPayment()
      .then(res => {
        if(res.data !== undefined && res.data.POK === 1) {
          this.open_result = true,
          this.type_result = 'success';
          this.message_result = this.$_('order_success');
          this.open = false;

          setTimeout(() => {
            window.location.href = '/';
          }, 3000);

        } else {
          this.open_result = true,
          this.type_result = 'error';
          this.message_result = this.$_('order_error');
        }
      });
    },
    getCurrentAddr() {

      if(
          this.$store.getters['panier/get_delivery_address'].TNLIG === undefined && 
          this.$store.getters['panier/get_billing_address'].TNLIG === undefined
        ) {

        cartService.getCurrentAddr()
        .then(res => {
          if(res.data.DS_O !== undefined) {
            res.data.DS_O.OUT.map(addr => {
  
              if(addr.TTYP_ADR === 'L') {
  
                // delete addr.TTYP_ADR;       
                // delete addr.TCPAYS;       
  
                this.$store.dispatch('panier/SET', {key: 'delivery_address', value: addr});
                this.delivery_address = addr;
                this.display_delivery_address = addr;
  
              } else if (addr.TTYP_ADR === 'F') {
  
                // delete addr.TTYP_ADR;       
                // delete addr.TCPAYS;       
  
                this.$store.dispatch('panier/SET', {key: 'billing_address', value: addr});
                this.billing_address = addr;
                this.display_billing_address = addr;
              }
            });
          }
        })
      } else {
    
          let obj = this.$store.getters['panier/get_delivery_address'];

          delete obj.TLPAYS;
          delete obj.TLPROV;
          delete obj.TTEL;
          // delete obj.TTYP_ADR;    
          // delete obj.TCPAYS;     
          delete obj.TNLIG;  
          delete obj.TADR_DEFAUT; 
          
          this.delivery_address = obj;

      
          let obj2 = this.$store.getters['panier/get_billing_address'];

          delete obj.TLPAYS;
          delete obj.TLPROV;
          delete obj.TTEL;
          // delete obj.TTYP_ADR;       
          // delete obj.TCPAYS;     
          delete obj.TNLIG;  
          delete obj.TADR_DEFAUT; 
          
          this.billing_address = obj2;
      }
    }
  },
  computed: {
    getSubTotal() {
      return this.$store.getters['panier/get_pmtht'];
    },
    getSubTotalTTC() {
      return this.$store.getters['panier/get_pmtttc'];
    },
    getDeliveryPrice () {
      return this.$store.getters['panier/get_pmttrsp'];
    },
    getTotal() {
      return this.$store.getters['panier/get_pmtttc'];
    },
    getDev() {
      return this.$store.getters['panier/get_pcdev'];
    },
    getBillingAddress() {
      return this.$store.getters['panier/get_billing_address'];
    },
    getDeliveryAddress() {
      return this.$store.getters['panier/get_delivery_address'];
    },
    getDisplayBillingAddress() {
      return this.$store.getters['panier/get_display_billing_address'];
    },
    getDisplayDeliveryAddress() {
      return this.$store.getters['panier/get_display_delivery_address'];
    },
    getPnumbon() {
      return  this.$store.getters['panier/get_pnbon'];
    },
    getPayment() {
      return this.payment;
    },
    getDisplayButton() {
      return this.$store.getters['produit/get_display_button_add_to_cart']
    },
    getPaymentReady() {
      return this.$store.getters['panier/get_payment_ready']
    },
  },
  watch: {
    getBillingAddress(addr) {
      Object.entries(addr).map(res => {
        if(this.billing_address[res[0]] !== undefined) {
          this.billing_address[res[0]] = res[1];
        }
      });
    },
    getDeliveryAddress(addr) {
      Object.entries(addr).map(res => {
        if(this.delivery_address[res[0]] !== undefined) {
          this.delivery_address[res[0]] = res[1];
        }
      });
    },
    getPnumbon() {
      this.getCurrentAddr()

      this.getDisplayCurrentAddr();
    },
    getPayment(val) {
      if(val === 'transfer') {
        this.button_title = this.$_('to_order')
      } else {
        this.button_title = this.$_('pay').toUpperCase()
      }
    },
    getDisplayDeliveryAddress(val) {

    }
  }
}
</script>

<style scoped>
.cart-summary-container {
  border: solid 1px #E9E9E9;
  padding: 25px;
}
.cart-summary-bottom {
  padding: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-summary-bottom span {
  font-size: var(--fz-md);
}
.cart-summary-bottom img {
  width: 9px;
  margin-right: 5px;
}
.cart-summary-line,
.cart-summary-total {
  display: flex;
  justify-content: space-between;
}
.cart-summary-total span{
  font-weight: bold;
}
.cart-summary-total-value {
  color: #F00B35;
}
.cart-summary-line-libelle {
  font-size: var(--fz-md);
  color: #8B8B8B;
  margin-bottom: 5px;
}
.cart-summary-total {
  margin: 25px 0px;
}
.cart-summary-line-value {
  font-size: var(--fz-md);
  font-weight: bold;
}
.cart-summary-validate {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.cart-summary-validate a {
  width: 100%;
  margin: 0px 0px 0px;
  text-align: center;
}
.cart-summary-delivery,
.cart-summary-billing {
  display: flex;
  flex-direction: column;
}
.cart-summary-delivery h3,
.cart-summary-billing h3 {
  margin: 10px 0px;
}
.cart-summary-delivery span,
.cart-summary-billing span {
  color: rgb(121, 121, 121);
  line-height: 1.4;
  font-size: var(--fz-sm);
  font-weight: bold;
}
.button-bar {
  display: block;
  text-align: center;
}
.button-bar .btn {
  margin: 0px 10px
}
.order-lock {
  font-size: .8rem;
  color: #F00B35;
  margin-top: 10px;
}
.btn-loading {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  margin: 3px;
  border: 3px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>